/**
 * Role -> default ERP landing page.
 *
 * Single source of truth shared by the Login redirect and the bare `/erp`
 * entry route, so a role can never land somewhere it cannot access (e.g. the
 * sales role must not fall through to /erp/dashboard, which is admin-only).
 *
 * Superadmin opens the Super Admin overview tab (first item in the Management
 * sidebar section). Sales roles open on Lead Integration, matching the sales
 * sidebar order in ERPLayout (leads, crm, quotations, salesinvoice, ...).
 */
export const ROLE_LANDING = {
  super_admin: '/erp/superadmin',
  admin: '/erp/dashboard',
  owner: '/erp/dashboard',
  manager: '/erp/dashboard',
  hr: '/erp/hr',
  finance: '/erp/accounts',
  accounts: '/erp/accounts',
  accountant: '/erp/accounts',
  operator: '/erp/operator',
  floor_manager: '/erp/production',
  sales: '/erp/leads',
  sales_manager: '/erp/leads',
  sales_executive: '/erp/leads',
  store: '/erp/inventory',
  store_manager: '/erp/inventory',
  transport: '/erp/transport',
  driver: '/erp/driver-dashboard',
  logistics: '/erp/transport',
  supervisor: '/erp/production',
  auditor: '/erp/ledger',
  ca: '/erp/ledger',
  dealer: '/erp/leads',
};

/** Returns the default ERP landing for a role, or the customer portal. */
export const landingForRole = (role) =>
  ROLE_LANDING[role] || '/portal';

export default ROLE_LANDING;